/**
 * Font definitions for AdminPortal UI
 * Uses standard font loading with proper fallbacks
 */

// Font family strings for theme - Europa Bold with standard web fonts
export const fontFamilies = {
  body: `'Roboto', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif`,
  heading: `'Europa Bold', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif`,
  fallback: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
}

// Font loading function (can be called in main.tsx to preload fonts)
export const loadFonts = () => {
  // Preload Google Fonts
  const link = document.createElement('link')
  link.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap'
  link.rel = 'preload'
  link.as = 'style'
  link.onload = () => {
    link.rel = 'stylesheet'
  }
  document.head.appendChild(link)
  
  // Load Europa Bold from local files if available
  const europaLink = document.createElement('link')
  europaLink.href = '/fonts/europa-bold.woff2'
  europaLink.rel = 'preload'
  europaLink.as = 'font'
  europaLink.type = 'font/woff2'
  europaLink.crossOrigin = 'anonymous'
  document.head.appendChild(europaLink)
  
  // Also preload WOFF fallback
  const europaWoffLink = document.createElement('link')
  europaWoffLink.href = '/fonts/europa-bold.woff'
  europaWoffLink.rel = 'preload'
  europaWoffLink.as = 'font'
  europaWoffLink.type = 'font/woff'
  europaWoffLink.crossOrigin = 'anonymous'
  document.head.appendChild(europaWoffLink)
}